
import Vue from 'vue'
import AppMixin from '@/_mixins/app'

const PsiQrSettings = Vue.extend({
    mixins: [AppMixin],
    data() {
        return {
            qrDescription: '',
            qrLanguage: 'nob',
        }
    },
    computed: {
        fileName() {
            return `qr_${this.currentProjectName}_${this.qrLanguage}.png`
        },
        languages() {
            return Object.values(this.$store.getters.languages).filter((language: any) => {
                return language.availableForUsers
            })
        },

        url() {
            return `https://internal.byggekortleser.no/api/qrcode/invite/${this.qrLanguage}/${
                this.currentProjectId
            }?size=820${this.qrDescription ? '&description=' + this.qrDescription : ''}`
        },
        urlInvite() {
            if (!this.currentProjectId) return ''
            return `https://chkbox.app/${this.qrLanguage}/invite/${this.currentProjectId}`
        },
    },
    methods: {
        copyToClipboard() {
            if (this.urlInvite) {
                navigator.clipboard.writeText(this.urlInvite)
                this.$store.commit('setSuccessSnackBar', {
                    subtitle: this.$t("psi_fe['qr_settings.url_copied_success']"),
                })
            }
        },
    },
    mounted() {
        this.qrLanguage = this.userLanguage
    },
})

export default PsiQrSettings
